export default "__VITE_ASSET__BkIj$3nm__"